import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import PaymentCG from '../../SaleBlock/PaymentCG/PaymentCG';
import EmailCheck from '../DebtPaymentComponents/emailCheck';
import ConsumerSelect from '../DebtPaymentComponents/consumerSelect';
import {followUpEnum, stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {cgTypeEnum} from '../../../../utilities/enums/cgTypeEnum';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentCreditCard = (props) => {
  const [mount, setMount] = useState(false);
  const [render, setRender] = useState(true);
  const [emailError, setEmailError] = useState(false);
  const [consumerDetails, setConsumerDetails] = useState(props.savedData);

  const [submitted, setSubmitted] = useState(false);

  const handleValidate = () => {
    if (submitted) {
      setSubmitted(false);
    }
  };

  const submitPaymentData = () => {
    setSubmitted(true);
    if (props.isPrivate) {
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Private Debt Payment';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'Credit Card Payment Details Page';
      reportParams.status = 'Ongoing';
      reportParams.banId = props.savedCustomerData?.number;
      reportParams.idNumber = props.savedCustomerData?.idNumber;
      reportParams.messageText = 'Debt Payment Details Button Clicked';
      reportParams.param1 = `סה"כ יתרה: ` + props.totalDebtPrivate + '₪';
      reportParams.param2 = `סכום לתשלום: ` + props.privateAmount + '₪';
      reportParams.customerName = props.savedCustomerData?.name;
      report(reportParams);
      gaEvent(
        gaParams.PRIVATEDEBT_PAYMENTPAGE_CONTINUE_CLICK.category,
        gaParams.PRIVATEDEBT_PAYMENTPAGE_CONTINUE_CLICK.eventType,
        gaParams.PRIVATEDEBT_PAYMENTPAGE_CONTINUE_CLICK.eventParams,
      );
    } else {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY.category,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY.eventParams,
      );
    }

    if (!props.isPrivate) {
      if (checkEmail()) {
        setEmailError(false);
        props.createAndSendPaymentData();
      } else if (props.isEmailRequestedError === '') {
        setEmailError(true);
      }
    } else {
      props.createAndSendPaymentData();
    }
  };

  function checkEmail() {
    return (props.isEmailRequested && props.isEmailRequestedError === '' && props.email !== '') || !props.isEmailRequested;
  }

  const setCodeAndHandleStep = (step) => {
    props.setFollowUpData({
      followUpType: followUpEnum.DifferentPaymentMethod,
      title: 'נשמח לשמוע מכם',
      text: 'השאירו פרטים ונחזור אליכם תוך יום עסקים אחד',
    });
    props.handleCurrentStep(step);
  };

  const popUpData = {
    title: 'חשוב שתדעו',
    text: 'אפשר לשלם באתר רק עם כרטיס אשראי.\n מעדיפים דרך אחרת? צרו איתנו קשר',
    buttonText: 'לשליחת הודעה',
    onclick: setCodeAndHandleStep,
  };

  useEffect(() => {
    if (props.isPrivate) {
      if (props.payForm?.confirmationNumber != '') {
        let reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Private Debt Payment';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = 'Credit Card Payment Details Page';
        reportParams.status = 'Ongoing';
        reportParams.banId = props.savedCustomerData?.number;
        reportParams.idNumber = props.savedCustomerData?.idNumber;
        reportParams.messageText = 'Payment Details CG OK';
        reportParams.subscriber = props.phoneNumber;
        reportParams.param1 = `סה"כ יתרה: ` + props.totalDebtPrivate + '₪';
        reportParams.param2 = `סכום לתשלום: ` + props.privateAmount + '₪';
        reportParams.customerName = props.savedCustomerData?.name;
        report(reportParams);
      } else if (props.payForm?.errorObj != null) {
        let reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Private Debt Payment';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = 'Credit Card Payment Details Page';
        reportParams.status = 'Ongoing';
        reportParams.banId = props.savedCustomerData?.number;
        reportParams.idNumber = props.savedCustomerData?.idNumber;
        reportParams.messageText = `Payment Details Failed CG. Code Error: ${props?.payForm?.errorObj?.errorId}`;
        reportParams.subscriber = props.phoneNumber;
        reportParams.param1 = `סה"כ יתרה: ` + props.totalDebtPrivate + '₪';
        reportParams.param2 = `סכום לתשלום: ` + props.privateAmount + '₪';
        reportParams.customerName = props.savedCustomerData?.name;
        report(reportParams);
      }
    }
  }, [props.payForm]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.currentStep === stepEnum.CREDITCARD) {
          setConsumerDetails(props.savedData);
          setRender(true);
          setMount(true);
          if (props.isPrivate) {
            gaEvent(
              gaParams.PRIVATEDEBT_PAYMENTPAGE_SHOW.category,
              gaParams.PRIVATEDEBT_PAYMENTPAGE_SHOW.eventType,
              gaParams.PRIVATEDEBT_PAYMENTPAGE_SHOW.eventParams,
            );

            let reportParams = getReportParams();
            reportParams.area = 'SelfCare';
            reportParams.subArea = 'Private Debt Payment';
            reportParams.channel = 'WebsitePrivate';
            reportParams.actionType = 'Credit Card Payment Details Page';
            reportParams.status = 'Ongoing';
            reportParams.banId = props.savedCustomerData?.number;
            reportParams.idNumber = props.savedCustomerData?.idNumber;
            reportParams.messageText = 'Debt Payment Details Page Displayed';
            reportParams.subscriber = props.phoneNumber;
            reportParams.param1 = `סה"כ יתרה: ` + props.totalDebtPrivate + '₪';
            reportParams.param2 = `סכום לתשלום: ` + props.privateAmount + '₪';
            reportParams.customerName = props.savedCustomerData?.name;
            report(reportParams);
          } else {
            gaEvent(
              gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY.category,
              gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY.eventType,
              gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY.eventParams,
            );
          }
        } else {
          setMount(false);
        }
      }
    },
    [props.currentStep],
  );

  const handleModal = (modalProps) => {
    if (props.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_PAYMENTPAGE_TOOLTIP_CLICK.category,
        gaParams.PRIVATEDEBT_PAYMENTPAGE_TOOLTIP_CLICK.eventType,
        gaParams.PRIVATEDEBT_PAYMENTPAGE_TOOLTIP_CLICK.eventParams,
      );
    } else {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_INFO.category,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_INFO.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_INFO.eventParams,
      );
    }

    props.openModal(modalProps);
  };

  const gaEventPayments = (e) => {
    if (props.isPrivate == false) {
      if (e && e.value > 1) {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_PAYMENTS.category,
          gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_PAYMENTS.eventType,
          'moreThanOnePayment',
        );
      }
    }
  };

  const gaEventCVV = () => {
    if (props.isPrivate == false) {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_CVV.category,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_CVV.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_CVV.eventParams,
      );
    }
  };

  const getPaymentNumber = () => {
    if (props.isPrivate) {
      if (
        Object.keys(props.paymentFloorData).every(function (k) {
          return props.paymentFloorData[k];
        })
      ) {
        const price = parseFloat(consumerDetails.amount);
        if (props.paymentFloorData.firstFloorAmount >= price) {
          return props.paymentFloorData.firstFloorPayments;
        } else if (props.paymentFloorData.firstFloorAmount < price && price <= props.paymentFloorData.secondFloorAmount) {
          return props.paymentFloorData.secondFloorPayments;
        } else if (props.paymentFloorData.secondFloorAmount < price && price <= props.paymentFloorData.thirdFloorAmount) {
          return props.paymentFloorData.thirdFloorPayments;
        } else return props.paymentFloorData.fourthFloorPayments;
      }
    } else {
      return 10;
    }
  };
  return render ? (
    <>
      {mount && (
        <Container fluid className='debtpayment-step creditcard-container'>
          <Row className='debtpayment-container justify-content-md-center'>
            <Col md='auto'>
              <BasicText text='תשלום חוב' classname='debtpayment-title' />
            </Col>
          </Row>
          <Row className='debtpayment-step-title justify-content-md-center'>
            <Col md='auto'>
              <BasicText text='פרטי תשלום' classname={'main-text-extra-bold'} />
            </Col>
          </Row>
          <Container className='p-0'>
            <ConsumerSelect
              {...consumerDetails}
              privateAmount={props.isPrivate ? props.privateAmount : null}
              selected
              isPrivate={props.isPrivate}
              onclick={handleModal}
              popUpProps={popUpData}
            />
            <Row className='justify-content-md-center creditcard-component'>
              <Col lg='4'>
                {props.selectedProvider === 'cellcom' ? (
                  <PaymentCG
                    totalPrice={props.isPrivate ? props.privateAmount : consumerDetails.amount}
                    onValid={handleValidate}
                    isHideTermsCheckbox
                    padding='0'
                    onSubmit={submitted}
                    showPaymentCount
                    numberOfPayments={getPaymentNumber()}
                    paymentRequestedQuantity={9}
                    noLoader
                    gaEventCVV={gaEventCVV}
                    gaEventPayments={gaEventPayments}
                    type={cgTypeEnum.DEBTPAYMENT}
                    isShowIdNumber={false}
                    customerId={consumerDetails.idNumber}
                    isAllowDebit={true}
                    source={props.source}
                  />
                ) : (
                  <PaymentCG
                    isShowIdNumber={true}
                    totalPrice={consumerDetails.amount}
                    onValid={handleValidate}
                    type={cgTypeEnum.DEBTPAYMENT}
                    isHideTermsCheckbox
                    padding='0'
                    onSubmit={submitted}
                    noLoader
                    gaEventCVV={gaEventCVV}
                    gaEventPayments={gaEventPayments}
                    isAllowDebit={true}
                    source={props.source}
                  />
                )}
              </Col>
            </Row>
            {!props.isPrivate ||
              (props.isPrivate && !props.bitPaymentOption && (
                <Row className='justify-content-md-center'>
                  <Col lg='4' className='background-container notification-container background invoice-by-email'>
                    <EmailCheck
                      handleCheckBox={props.setEmailRequested}
                      checked={props.isEmailRequested}
                      emailError={emailError}
                      isPrivate={props.isPrivate && !props.bitPaymentOption ? true : false}
                    />
                  </Col>
                </Row>
              ))}
          </Container>
          <Row className='justify-content-md-center footer-btn mt-3'>
            <Col md='auto' className={`${!props.ccToken || !checkEmail() ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness={!props.isPrivate} text={'המשך לתשלום'} onclick={() => submitPaymentData()} />
            </Col>
          </Row>
        </Container>
      )}
    </>
  ) : null;
};

export default DebtPaymentCreditCard;
